import React from 'react';
import { ADMIN_CONSOLE_TABS, type AdminConsoleTabId } from './types';

interface AdminConsoleTabsProps {
  activeTab: AdminConsoleTabId;
  onTabChange: (tab: AdminConsoleTabId) => void;
}

export const AdminConsoleTabs: React.FC<AdminConsoleTabsProps> = ({ activeTab, onTabChange }) =>
{
  return (
    <div className="flex-shrink-0 border-b border-[#ddd] dark:border-[#4a4c4c] px-6 mt-6">
      <div className="flex flex-wrap gap-0">
        {ADMIN_CONSOLE_TABS.map(tab =>
        {
          const isActive = tab.id === activeTab;
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className={`px-3 py-2 text-[0.8em] whitespace-nowrap border-b-2 transition-colors ${
                isActive
                  ? 'border-[#62aacb] text-[#62aacb] font-medium dark:!text-[#beb7ac]'
                  : 'border-transparent text-[#555] dark:text-[#6e6860] hover:text-[#62aacb] dark:hover:text-[#62aacb]'
              }`}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};
